module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('tab', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.index),
      expression: "index"
    }],
    attrs: {
      "line-width": 2,
      "active-color": "#fc378c"
    },
    domProps: {
      "value": (_vm.index)
    },
    on: {
      "input": function($event) {
        _vm.index = $event
      }
    }
  }, _vm._l((_vm.list2), function(item) {
    return _c('tab-item', {
      staticClass: "vux-center",
      attrs: {
        "selected": _vm.demo2 === item
      },
      on: {
        "click": function($event) {
          _vm.demo2 = item
        },
        "on-item-click": function($event) {
          _vm.barHandler(item)
        }
      }
    }, [_vm._v(_vm._s(item))])
  })), _vm._v(" "), _c('loading', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.show1),
      expression: "show1"
    }],
    attrs: {
      "text": _vm.text1
    },
    domProps: {
      "value": (_vm.show1)
    },
    on: {
      "input": function($event) {
        _vm.show1 = $event
      }
    }
  }), _vm._v(" "), _c('swiper', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.index),
      expression: "index"
    }],
    attrs: {
      "height": "500px",
      "show-dots": false
    },
    domProps: {
      "value": (_vm.index)
    },
    on: {
      "input": function($event) {
        _vm.index = $event
      }
    }
  }, _vm._l((_vm.list2), function(item) {
    return _c('swiper-item', [(item === '成交价格') ? _c('div', [_c('div', {
      staticClass: "tab-swiper vux-center"
    }, [_c('div', {
      attrs: {
        "id": "dealQty"
      }
    })])]) : (item === '成交量') ? _c('div', [_c('div', {
      staticClass: "tab-swiper vux-center"
    }, [_c('div', {
      attrs: {
        "id": "dealPrice"
      }
    })])]) : (item === '户型分布') ? _c('div', [_c('div', {
      staticClass: "tab-swiper vux-center"
    }, [_c('div', {
      attrs: {
        "id": "dealType"
      }
    })])]) : _c('div', [_c('div', {
      staticClass: "tab-swiper vux-center"
    }, [_vm._v(_vm._s(item) + " Container")])])])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-34aa8450!./~/.1.0.35@vux-loader/src/template-loader.js!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/DetailTest.vue
// module id = 276
// module chunks = 2